import { PdfViewerDownloadAssetEvent } from '../../../PdfViewer';
export class ErrorMessageComponent {
    constructor(container, config, eventBus) {
        this.container = container;
        this.config = config;
        this.eventBus = eventBus;
        this.download = () => {
            this.eventBus.dispatch(new PdfViewerDownloadAssetEvent());
            if (window && window.location && window.location.assign) {
                window.location.assign(this.config.downloadUrl);
            }
            else {
                window.open(this.config.downloadUrl);
            }
        };
        this.onOnline = () => {
            this.showDownloadElement();
            this.updateErrorText();
        };
        this.onOffline = () => {
            this.hideDownloadElement();
            this.updateErrorText();
        };
        this.onClose = () => {
            this.destroy();
        };
        this.render();
    }
    get isOnline() {
        return navigator && navigator.onLine;
    }
    get errorText() {
        if (!this.isOnline) {
            return this.config.offlineErrorText;
        }
        return this.config.errorText;
    }
    render() {
        this.element = document.createElement('div');
        this.element.classList.add('pdf-viewer-error-message');
        this.messageElement = document.createElement('span');
        this.messageElement.innerText = this.errorText;
        this.element.appendChild(this.messageElement);
        if (!this.config.disableDownload) {
            this.downloadElement = document.createElement('button');
            this.downloadElement.classList.add('pdf-viewer-error-message__download');
            this.downloadElement.type = 'button';
            if (this.config.tintColor) {
                this.downloadElement.style.color = this.config.tintColor;
            }
            this.downloadElement.addEventListener('click', this.download);
            this.downloadElement.innerText = this.config.downloadText;
            this.element.appendChild(this.downloadElement);
        }
        this.closeButtonElement = document.createElement('button');
        this.closeButtonElement.classList.add('pdf-viewer-error-message__close');
        this.closeButtonElement.type = 'button';
        this.closeButtonElement.addEventListener('click', this.onClose);
        this.closeButtonElement.setAttribute('aria-label', this.config.closeText);
        this.closeButtonElement.innerText = '✕';
        this.element.appendChild(this.closeButtonElement);
        this.container.appendChild(this.element);
        window.addEventListener('online', this.onOnline);
        window.addEventListener('offline', this.onOffline);
    }
    updateErrorText() {
        this.messageElement.innerText = this.errorText;
    }
    showDownloadElement() {
        if (!this.config.disableDownload && this.downloadElement) {
            this.downloadElement.classList.remove('hidden');
        }
    }
    hideDownloadElement() {
        if (!this.config.disableDownload && this.downloadElement) {
            this.downloadElement.classList.add('hidden');
        }
    }
    destroy() {
        if (this.closeButtonElement) {
            this.closeButtonElement.removeEventListener('click', this.onClose);
        }
        window.removeEventListener('online', this.onOnline);
        window.removeEventListener('offline', this.onOffline);
        if (this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }
        this.element.innerHTML = '';
        this.element = null;
        this.messageElement = null;
        this.downloadElement = null;
        this.closeButtonElement = null;
    }
}
//# sourceMappingURL=error-message.component.js.map